/*eslint max-lines-per-function: ["error", 250]*/
/*eslint complexity: ["error", 62]*/
import React from 'react';

import {
  CreateUpdateEstimateItemDto,
  GetProfileDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import CurrencyControl from '../../../app/components/CurrencyControl';

import ProfileFieldName from './ProfileFieldName';
import { isFieldHidden } from './CommissionService';

interface PurchaseParamsProps {
  estimateItem: CreateUpdateEstimateItemDto;
  profile?: GetProfileDto;
  readonly?: boolean;
  lang: string;
  propertyChange?: (obj: Partial<CreateUpdateEstimateItemDto>) => void;
}

export const PurchaseParams: React.FC<PurchaseParamsProps> = props => {
  const schema = props.profile?.schema;

  const propertyChange = (obj: Partial<CreateUpdateEstimateItemDto>) => {
    if (props.propertyChange) {
      props.propertyChange(obj);
    }
  };

  return (
    <>
      {schema?.rcPurchase &&
        !isFieldHidden(
          'rcPurchase',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="rcPurchase"
            schema={schema?.rcPurchase}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.rcPurchase}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  rcPurchase: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.purchaseSurchargePercent &&
        !isFieldHidden(
          'purchaseSurchargePercent',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="purchaseSurchargePercent"
            schema={schema?.purchaseSurchargePercent}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.purchaseSurchargePercent}
              percentage={true}
              decimalScale={12}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  purchaseSurchargePercent: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.purchaseDiscountPercent &&
        !isFieldHidden(
          'purchaseDiscountPercent',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="purchaseDiscountPercent"
            schema={schema?.purchaseDiscountPercent}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.purchaseDiscountPercent}
              percentage={true}
              max={100}
              decimalScale={12}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  purchaseDiscountPercent: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.purchaseNet &&
        !isFieldHidden(
          'purchaseNet',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="purchaseNet"
            schema={schema?.purchaseNet}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.purchaseNet}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  purchaseNet: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.purchaseTechnicalCost &&
        !isFieldHidden(
          'purchaseTechnicalCost',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="purchaseTechnicalCost"
            schema={schema?.purchaseTechnicalCost}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.purchaseTechnicalCost}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  purchaseTechnicalCost: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.purchaseBeerTax &&
        !isFieldHidden(
          'purchaseBeerTax',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="purchaseBeerTax"
            schema={schema?.purchaseBeerTax}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.purchaseBeerTax}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  purchaseBeerTax: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.purchasePrintingCosts &&
        !isFieldHidden(
          'purchasePrintingCosts',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="purchasePrintingCosts"
            schema={schema?.purchasePrintingCosts}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.purchasePrintingCosts}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  purchasePrintingCosts: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.purchaseOperatingFee &&
        !isFieldHidden(
          'purchaseOperatingFee',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="purchaseOperatingFee"
            schema={schema?.purchaseOperatingFee}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.purchaseOperatingFee}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  purchaseOperatingFee: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.purchaseBlockSurcharge &&
        !isFieldHidden(
          'purchaseBlockSurcharge',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="purchaseBlockSurcharge"
            schema={schema?.purchaseBlockSurcharge}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.purchaseBlockSurcharge}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  purchaseBlockSurcharge: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.purchaseTransferCosts &&
        !isFieldHidden(
          'purchaseTransferCosts',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="purchaseTransferCosts"
            schema={schema?.purchaseTransferCosts}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.purchaseTransferCosts}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  purchaseTransferCosts: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
    </>
  );
};
